<nz-header>
    <adspt-header
        class="a-fx-between-center a-fx a-fx-fill"
        [hideLinks]="isOauthApp()"
        [disableLinks]="disableLinks()"
    />
</nz-header>

<adspt-global-side-nav [disableLinks]="disableLinks()" />

<nz-content [ngClass]="layoutClass()">
    <ng-content></ng-content>
</nz-content>
